<template>
    <div>
        <div class="mobile-sidebar">
            <el-menu :default-active="$route.path" router @click.native="close">
                <el-menu-item index="/statistic"><i class="material-icons md-24">equalizer</i> {{ $t('statistics') }}</el-menu-item>
                <el-menu-item index="/streams"><i class="material-icons md-24">link</i> {{ $t('streams') }}</el-menu-item>
                <el-menu-item index="/offers"><i class="material-icons md-24">&#xe87d;</i> {{ $t('offers') }}</el-menu-item>
                <el-menu-item index="/payments"><i class="material-icons md-24">&#xe850;</i> {{ $t('payments') }}</el-menu-item>
                <el-menu-item index="/news"><i class="material-icons md-24">start_rate</i> {{ $t('news') }}<el-badge class="mark" :value="$store.getters.getNewsUnread" v-if="$store.getters.getNewsUnread" /></el-menu-item>
                <el-menu-item index="/profile"><i class="material-icons md-24">settings</i> {{ $t('setting') }}</el-menu-item>
                <el-menu-item index="/tickets"><i class="material-icons md-24">chat</i> {{ $t('support') }}<el-badge class="mark" :value="$store.getters.getTicketUnread" v-if="$store.getters.getTicketUnread" /></el-menu-item>
                <el-menu-item index="/help"><i class="material-icons md-24">help</i> {{ $t('help') }}</el-menu-item>
            </el-menu>
        </div>
        <div class="modal" @click="close"></div>
    </div>
</template>

<script>
    export default {
        name: "MobileSidebar",
        props: ['visible'],
        // watch: {
        //     '$route': {
        //         handler () {
        //             this.$emit('close');
        //             console.log('ewdf');
        //         },
        //         deep: true
        //     },
        // },
        methods: {
            close () {
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        background-color: rgba(0,0,0,0.61);
        z-index: 2050;
    }
</style>